var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTipsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 53,
    viewBox: "0 0 56 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.989 40.6667H35.008M28 1V3.83333M47.092 8.46867L44.971 10.4718M55 26.5H52M4 26.5H1M11.029 10.4718L8.908 8.46867M17.392 36.5187C15.2946 34.5373 13.8664 32.013 13.2879 29.265C12.7095 26.5171 13.0068 23.6688 14.1422 21.0804C15.2776 18.492 17.2002 16.2797 19.6669 14.7232C22.1335 13.1667 25.0334 12.336 28 12.336C30.9666 12.336 33.8665 13.1667 36.3331 14.7232C38.7998 16.2797 40.7224 18.492 41.8578 21.0804C42.9933 23.6688 43.2905 26.5171 42.7121 29.265C42.1336 32.013 40.7054 34.5373 38.608 36.5187L36.964 38.0685C36.0241 38.9563 35.2786 40.0103 34.7701 41.1702C34.2615 42.3302 33.9998 43.5734 34 44.8288V46.3333C34 47.8362 33.3679 49.2776 32.2426 50.3403C31.1174 51.403 29.5913 52 28 52C26.4087 52 24.8826 51.403 23.7574 50.3403C22.6321 49.2776 22 47.8362 22 46.3333V44.8288C22 42.293 20.932 39.8592 19.036 38.0685L17.392 36.5187Z",
    stroke: "#E4BE7E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsIcon);
export default __webpack_public_path__ + "static/media/tips_icon.763f4b2541772944036ba9c496e4de4b.svg";
export { ForwardRef as ReactComponent };